export class User {

  constructor() {
    this.setupEventListeners();
  }

  setupEventListeners = () => {
    document.querySelector('#delete-account').addEventListener('click', this.deleteUser.bind(this));
    document.querySelector('#delete-user-submit').addEventListener('submit', this.submitDeleteUser.bind(this));
    this.attachFormCancelListeners();
  }

  /* EVENT LISTENERS */
  attachFormCancelListeners = () => {
    document.querySelectorAll('.form-cancel').forEach(button => {
      button.addEventListener('click', () => {
        this.hideModal('.form-modal');
      });
    });
  }
  /* END EVENT LISTENERS */

  /* MODAL FORMS */
  showModal = (modalSelector) => {
    const modal = document.querySelector(modalSelector);
    if(modal){
      if(modal.classList.contains('display-flex-modal')){
        this.hideModal('.form-modal');
      }
      else {
        this.hideModal('.form-modal');
        modal.classList.add('display-flex-modal');
        const firstInput = modal.querySelector('input[type="text"], input[type="email"], input[type="number"], textarea');
        if (firstInput) {
          firstInput.focus();
        }
      }
    }
  }

  hideModal = (modalSelector) => {
    const modals = document.querySelectorAll(modalSelector);
    modals.forEach(modal => {
      modal.classList.remove('display-flex-modal'); 
      let form = modal.querySelector('form');
      if (form) {
        const inputs = form.querySelectorAll('input');
        inputs.forEach(input => {
          if (input.type === 'text') {
            input.value = '';
          }
        });
        form.reset();
      }
      this.resetFormErrors(modal); 
    });
  }  

  resetFormErrors = (modal) => {
    let errors = modal.querySelectorAll('.form-error');
    errors.forEach(error => {
      error.style.display = 'none';
    });
  }
  /* END MODAL FORMS */

  /* ACTIONS */
  deleteUser = () => {
    const userUrl = `/users/${currentUserId}/data`;
    this.ajaxGet(userUrl).then(data => {
      if (data) {
        const confirmInput = document.getElementById('confirm-delete');
        const deleteButton = document.getElementById('delete-user-submit');
        const userEmail = data.email;
        confirmInput.addEventListener('input', function() {
          if (this.value === userEmail) {
            deleteButton.removeAttribute('disabled');
          } else {
            deleteButton.setAttribute('disabled', 'disabled');
          }
        });
      } else {
        console.log('No data received or an error occurred.');
      }
    }).catch(error => {
      console.error('Error in fetching data:', error);
    });
    this.showModal('.delete-form-modal');
  };

  submitDeleteUser = (event) => {
    this.ajaxForm(event, 'PATCH', (data, form) => {
      return;
    });
  };
  /* END ACTIONS */

  /* AJAX */
  ajaxGet = async (url) => {
    try {
  
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      return data;
  
    } catch (error) {
      console.error('Failed to fetch data:', error);
      return null; // Return null in case of an error
    }
  };

  
  ajaxForm = async (event, method, successCallback) => {
    event.preventDefault();
    const form = event.target;
    let formData = new FormData(form);
  
    try {
      const response = await fetch(form.action, {
        method: method,
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      if (data.success && successCallback) {
        successCallback(data, form);
      } else {
        console.error('Error:', data.error);
        alert('An error occurred: ' + data.error);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred during submission: ' + error.message);
    }
  };
  /* END AJAX */

}

export default User;
